import { IAction } from "../utils";
import { reducerTypes } from "./types";
import { ICollections, ICollectionProducts } from "../../interfaces/collections";
import { IPageInfo } from "../../interfaces/common";


export interface ICollectionsReducer {
  collections: ICollections[];
  collection: ICollectionProducts;
  loading: string;
  pageInfo: IPageInfo;
}

export const INITIAL: ICollectionsReducer = {
    collections: [],
    collection: {
      items: [],
    },
    pageInfo: {
      pageIndex: 0,
      totalPages: 0,
      totalCount: 0,
      pageSize: 12,
    },
    loading: '',
};

export const CollectionsReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
      case reducerTypes.GET_ALL_COLLECTIONS:
        return { ...state, collections: payload };
      case reducerTypes.GET_COLLECTION:
        return { ...state, collection: payload };
        case reducerTypes.GET_PAGE_INFO:
          return { ...state, pageInfo: payload };
        case reducerTypes.IS_LOADING:
            return { ...state, loading: payload };
    default:
      return state;
  }
};
